module.exports = __webpack_public_path__ + "static/media/discover.ce72651e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/discover.svg
// module id = 800
// module chunks = 0